export const UPDATE_FINAL_EXAM_STATUS_BEGIN = "UPDATE_FINAL_EXAM_STATUS_BEGIN";
export const UPDATE_FINAL_EXAM_STATUS_FULFILLED =
  "UPDATE_FINAL_EXAM_STATUS_FULFILLED";
export const UPDATE_FINAL_EXAM_STATUS_REJECTED =
  "UPDATE_FINAL_EXAM_STATUS_REJECTED";

const initialFinalExamState = {
  loading: false,
  result: [],
  error: null
};

export function toggleFinalExamReducer(
  state = initialFinalExamState,
  action = {}
) {
  switch (action.type) {
    case UPDATE_FINAL_EXAM_STATUS_BEGIN: {
      return { ...state, loading: true, error: null };
    }
    case UPDATE_FINAL_EXAM_STATUS_FULFILLED: {
      return { ...state, loading: false, error: null, result: action.payload };
    }
    case UPDATE_FINAL_EXAM_STATUS_REJECTED: {
      return { ...state, loading: false, error: action.payload.error };
    }
    default: {
      return { ...state };
    }
  }
}
